import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsUsuarioClienteClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/usuario-cliente', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/usuario-cliente', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Tipo Pedido Estab');
    }
  }

  async findOneUsuario(id) {
    try {
      const { data } = await this.api.get(`/usuario-cliente/usuario/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Pedido Estab');
    }
  }

  async findOneRepresentante(id) {
    try {
      const { data } = await this.api.get(`/usuario-cliente/cliente/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Tipo Pedido Estab');
    }
  }

  async destroy(usuarioid, representanteid) {
    try {
      const { data: response } = await this.api.delete(`/usuario-cliente/usuario/${usuarioid}/cliente/${representanteid}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async listarClienteNaoSelecionados(queries) {
    try {
      return await this.api.get('/usuario-cliente/listarClienteNaoSelecionados', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async listarClienteSelecionados(queries) {
    try {
      return await this.api.get('/usuario-cliente/listarClienteSelecionados', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async removerTodosClienteSelecionados(usuarioId) {
    try {
      const { data: response } = await this.api.delete(`/usuario-cliente/removerTodosClienteSelecionados/${usuarioId}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async removerSelecionadoClienteSelecionado(data) {
    try {
      const { data: response } = await this.api.post('/usuario-cliente/removerSelecionadoClienteSelecionado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async adicionarTodosCliente(usuarioId) {
    try {
      const { data: response } = await this.api.post(`/usuario-cliente/adicionarTodosCliente/${usuarioId}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async adicionarSelecionadoClienteNaoSelecionado(data) {
    try {
      const { data: response } = await this.api.post('/usuario-cliente/adicionarSelecionadoClienteNaoSelecionado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }
}
